import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import BackIcon from '../Icons/BackIcon';
import './BreadcrumbsPageTitle.scss';

const BreadcrumbsPageTitle = ({ routes, backPath }) => (
  <div className="breadcrumbs-page-title-wrapper">
    <Link to={backPath || routes[routes.length - 2].route}>
      <BackIcon />
    </Link>

    <div className="breadcrumb-routes-wrapper">
      {routes.map(({ title, route }, index) => {
        if (index === routes.length - 1) {
          return (
            <div key={title} className="title breadcrumb-title">
              {title}
            </div>
          );
        }

        return (
          <Fragment key={route}>
            <Link to={route} className="title breadcrumb-title title-link">
              {title}
            </Link>
            <div className="separator title">-</div>
          </Fragment>
        );
      })}
    </div>
  </div>
);
BreadcrumbsPageTitle.defaultProps = {
  backPath: '',
};

BreadcrumbsPageTitle.propTypes = {
  routes: PropTypes.array.isRequired,
  backPath: PropTypes.string,
};

export default BreadcrumbsPageTitle;
